(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3458],{

/***/ 965700:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);


var LoaderIcon = function(props) {
    var waterSplashLoader = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "waterSplashLoader",
            style: props.style,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {})
            ]
        });
    };
    var ellipsis = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "ds-ellipsis-loader",
            style: props.style,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {})
            ]
        });
    };
    var _renderLoader = function(type) {
        switch(type){
            case "water_splash_loader":
                return waterSplashLoader();
            case "ellipsis":
            default:
                return ellipsis();
        }
    };
    return _renderLoader(props.type || "");
};
/* harmony default export */ __webpack_exports__["Z"] = (LoaderIcon);


/***/ }),

/***/ 601523:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l": function() { return /* binding */ ArrowCouple; },
  "e": function() { return /* binding */ ArrowIcon; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(693967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/Carousel/components/Arrows/ArrowIcons.tsx



var getBorderRadiusAccToShape = function(shape) {
    switch(shape){
        case "circular":
            return "18";
        case "square":
            return "0";
        case "rounded":
            return "5";
    }
};
function ArrowRightV1(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 36 36"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "36",
                height: "36",
                fill: props.bgColor || "#fff",
                opacity: typeof props.bgOpacity === "number" ? props.bgOpacity : 0.4,
                rx: getBorderRadiusAccToShape(props.iconShape),
                transform: "matrix(-1 0 0 1 36 0)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_112_2612)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    stroke: props.arrowColor || "#fff",
                    strokeWidth: "1.5",
                    d: "M15.578 11.828l5.819 5.818-5.819 5.819"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_112_2612",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "20.571",
                        height: "20.571",
                        fill: "#fff",
                        rx: "10.286",
                        transform: "matrix(0 1 1 0 7.7 7.713)"
                    })
                })
            })
        ]
    }));
}
function ArrowLeftV1(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 36 36"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "36",
                height: "36",
                fill: props.bgColor || "#fff",
                opacity: typeof props.bgOpacity === "number" ? props.bgOpacity : 0.4,
                rx: getBorderRadiusAccToShape(props.iconShape)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_112_2596)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    stroke: props.arrowColor || "#fff",
                    strokeWidth: "1.5",
                    d: "M20.422 11.828l-5.819 5.818 5.819 5.819"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_112_2596",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "20.571",
                        height: "20.571",
                        x: "28.301",
                        y: "7.713",
                        fill: "#fff",
                        rx: "10.286",
                        transform: "rotate(90 28.3 7.713)"
                    })
                })
            })
        ]
    }));
}
function ArrowRightV2(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: "36",
        height: "24",
        fill: "none",
        viewBox: "0 0 36 24"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "36",
                height: "24",
                fill: "#fff",
                opacity: "0.2",
                rx: getBorderRadiusAccToShape(props.iconShape),
                transform: "matrix(-1 0 0 1 36 0)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#D9D9D9",
                d: "M19.417 16.333L24 11.667l-4.583 4.666zM24 11.667L19.417 7 24 11.667zm0 0H13h11z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                stroke: "#fff",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "1.5",
                d: "M19.417 16.333L24 11.667m0 0L19.417 7M24 11.667H13"
            })
        ]
    }));
}
function ArrowLeftV2(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: "36",
        height: "24",
        fill: "none",
        viewBox: "0 0 36 24"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "36",
                height: "24",
                fill: "#fff",
                opacity: "0.2",
                rx: getBorderRadiusAccToShape(props.iconShape)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#D9D9D9",
                d: "M16.583 16.333L12 11.667l4.583 4.666zM12 11.667L16.583 7 12 11.667zm0 0h11-11z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                stroke: "#fff",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "1.5",
                d: "M16.583 16.333L12 11.667m0 0L16.583 7M12 11.667h11"
            })
        ]
    }));
}
function ArrowLeftV3(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "50",
        height: "50",
        viewBox: "0 0 50 50",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                filter: "url(#filter0_d_255_271)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                        filter: "url(#filter1_d_255_271)",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            x: "7",
                            y: "5",
                            width: "36",
                            height: "36",
                            rx: getBorderRadiusAccToShape(props.iconShape),
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                        "clip-path": "url(#clip0_255_271)",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M27.4159 16.83L21.5974 22.6484L27.4159 28.4669",
                            stroke: "#111C36",
                            "stroke-width": "2"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                        id: "filter0_d_255_271",
                        x: "0",
                        y: "0",
                        width: "50",
                        height: "50",
                        filterUnits: "userSpaceOnUse",
                        "color-interpolation-filters": "sRGB",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                                "flood-opacity": "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {
                                dy: "2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                stdDeviation: "3.5"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_255_271"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_255_271",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                        id: "filter1_d_255_271",
                        x: "5.5",
                        y: "3.5",
                        width: "39",
                        height: "39",
                        filterUnits: "userSpaceOnUse",
                        "color-interpolation-filters": "sRGB",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                                "flood-opacity": "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                stdDeviation: "0.75"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.0666667 0 0 0 0 0.109804 0 0 0 0 0.211765 0 0 0 0.2 0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_255_271"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_255_271",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "clip0_255_271",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            x: "35.2891",
                            y: "12.7168",
                            width: "20.5714",
                            height: "20.5714",
                            rx: "10.2857",
                            transform: "rotate(90 35.2891 12.7168)",
                            fill: "white"
                        })
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/tailwind-merge/dist/bundle-mjs.mjs
var bundle_mjs = __webpack_require__(798388);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/Carousel/components/Arrows/index.tsx





var ArrowIcon = function(props) {
    var _onClick = props.onClick, onClick = _onClick === void 0 ? function() {} : _onClick, _imageProps = props.imageProps, imageProps = _imageProps === void 0 ? {} : _imageProps, arrowDirection = props.arrowDirection, arrowType = props.arrowType;
    var Element = null;
    var _imageProps1 = (0,_object_spread/* default */.Z)({
        height: 36,
        width: 36,
        style: {},
        className: "",
        bgColor: "",
        bgOpacity: "",
        arrowColor: "",
        isShadowTypeIcon: false
    }, imageProps);
    var addShadow = _imageProps1.isShadowTypeIcon;
    switch(arrowType){
        case "v1":
            Element = arrowDirection === "left" ? ArrowLeftV1 : ArrowRightV1;
            break;
        case "v2":
            Element = arrowDirection === "left" ? ArrowLeftV2 : ArrowRightV2;
            break;
        case "v3":
            Element = ArrowLeftV3;
            break;
        default:
            Element = null;
    }
    if (!Element) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,bundle_mjs/* twMerge */.m6)("tw-pointer-events-auto tw-cursor-pointer", _imageProps1.className, addShadow ? " tw-inline-block " : ""),
        style: {
            height: imageProps.height,
            width: imageProps.width,
            filter: addShadow ? "drop-shadow(0 4px 10px #00000029)" : ""
        },
        onClick: onClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Element, (0,_object_spread/* default */.Z)({}, _imageProps1))
    });
};
var ArrowCouple = function(param) {
    var _handleNextClick = param.handleNextClick, handleNextClick = _handleNextClick === void 0 ? function() {} : _handleNextClick, _handlePrevClick = param.handlePrevClick, handlePrevClick = _handlePrevClick === void 0 ? function() {} : _handlePrevClick, _isVisible = param.isVisible, isVisible = _isVisible === void 0 ? false : _isVisible, _arrowType = param.arrowType, arrowType = _arrowType === void 0 ? "v1" : _arrowType, _className = param.className, className = _className === void 0 ? "" : _className, _containerClass = param.containerClass, containerClass = _containerClass === void 0 ? "" : _containerClass, _imageProps = param.imageProps, imageProps = _imageProps === void 0 ? {} : _imageProps, _style = param.style, style = _style === void 0 ? {} : _style;
    if (!isVisible) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: style,
        className: classnames_default()("tw-absolute tw-top-[50%] tw-flex tw-w-[100%] tw-translate-y-[-50%] tw-items-center tw-justify-between tw-px-[40px]", className, containerClass),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowIcon, {
                onClick: handlePrevClick,
                arrowDirection: "left",
                arrowType: arrowType,
                imageProps: imageProps
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowIcon, {
                onClick: handleNextClick,
                arrowDirection: "right",
                arrowType: arrowType,
                imageProps: imageProps
            })
        ]
    });
};


/***/ }),

/***/ 923458:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Reels": function() { return /* reexport */ Reels; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(307297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(150066);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/components/Reels/ReelsStyledModules.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 100vw;\n  position: ",
        ";\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: ",
        ";\n  max-height: 100%;\n  width: 100%;\n  z-index: 9999;\n  overflow: hidden;\n  overscroll-behavior: none;\n  background-color: #000000;\n\n  @media screen and (min-width: 769px) {\n    background-color: transparent;\n    position: relative;\n    /* max-width: 728px; */\n    height: 100vh;\n    display: flex;\n    align-items: center;\n    padding: 0 40px;\n    margin: 0 auto;\n  }\n\n  @media screen and (min-width: 968px) {\n    /* max-width: 840px; */\n  }\n\n  @media screen and (min-width: 1286px) {\n    max-width: 1200px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  list-style: none;\n  overflow-y: auto;\n  height: ",
        ";\n\n  /* contain -> prevent accidentally going back or triggering other swipe events */\n  overscroll-behavior: none;\n\n  /* hide scroll bar */\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n\n  /* momentum scroll on iOS */\n  -webkit-overflow-scrolling: touch;\n\n  /* disbable vertical scroll for touch */\n  touch-action: pan-y pan-x;\n\n  /* scroll snapping */\n  scroll-snap-type: y mandatory;\n\n  @media screen and (min-width: 769px) {\n    touch-action: none;\n    width: 540px;\n    max-width: 700px;\n    gap: ",
        "px;\n    scroll-snap-type: x mandatory;\n    padding: 0 calc(250px - 45px); /** Removed half of the gap */\n    margin: 0 auto;\n    flex-direction: row;\n    align-items: center;\n    overflow-x: scroll;\n    overflow-y: hidden;\n    max-height: 100vh;\n  }\n\n  @media screen and (min-width: 968px) {\n    width: 700px;\n    max-width: 800px;\n    gap: ",
        "px;\n    padding: 0 calc(350px - 45px); /** Removed half of the gap */\n    margin: 0 auto;\n  }\n\n  @media screen and (min-width: 1068px) {\n    width: unset;\n    max-width: 1000px;\n    padding: 0 calc(360px - 45px); /** Removed half of the gap */\n  }\n\n  /* @media screen and (min-width: 968px) {\n    width: 800px;\n    padding: 0 calc(400px - 45px);\n  }\n\n  @media screen and (min-width: 1024px) {\n    width: 900px;\n    padding: 0 calc(450px - 45px);\n  }\n\n  @media screen and (min-width: 1280px) {\n    width: 1200px;\n    padding: 0 calc(600px - 45px);\n  } */\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overscroll-behavior: none;\n  width: 100vw;\n  height: ",
        ";\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n  background-color: #000000;\n  transition: scale 500ms linear;\n  position: relative;\n\n  /* scroll snapping */\n  scroll-snap-align: center;\n\n  /* maybe this will work in the future \uD83E\uDD37‍♂️ */\n  scroll-snap-stop: always;\n\n  @media screen and (min-width: 768px) {\n    overflow: hidden;\n    width: ",
        ";\n    height: ",
        ";\n    border-radius: ",
        ";\n\n    /* scroll snapping */\n    scroll-snap-align: center;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var ReelsViewportWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ReelsViewportWrapper",
    componentId: "sc-f8c3c0b3-0"
})(_templateObject(), function(props) {
    return props.isMobile ? "fixed" : "unset";
}, function(props) {
    return props.isMobile && props.mobileHeight ? "".concat(props.mobileHeight, "px") : "100%";
});
var ReelsListWrapper = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    displayName: "ReelsListWrapper",
    componentId: "sc-f8c3c0b3-1"
})(_templateObject1(), function(props) {
    return props.mobileHeight ? "".concat(props.mobileHeight, "px") : "100%";
}, function(props) {
    return props.columnGap;
}, function(props) {
    return props.columnGap;
});
/* height: ${(props) => `${props.mobileHeight}px` || '100vh'}; */ var ReelItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    displayName: "ReelItem",
    componentId: "sc-f8c3c0b3-2"
})(_templateObject2(), function(props) {
    return "".concat(props.mobileHeight, "px") || 0;
}, function(props) {
    return "".concat(props.width, "px") || 0;
}, function(props) {
    return "".concat(props.height, "px") || 0;
}, function(props) {
    return props.borderRadius;
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(147568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(629815);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(197582);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(693967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/WIdgetPropertiesBasic/components/Button/index.tsx + 1 modules
var Button = __webpack_require__(846976);
// EXTERNAL MODULE: ./src/config/paymentLinks.js
var paymentLinks = __webpack_require__(196668);
// EXTERNAL MODULE: ./src/utils/formatPricing.ts
var formatPricing = __webpack_require__(154065);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicDesignsUtilities/ContentButtonAnimationStyle.module.scss
var ContentButtonAnimationStyle_module = __webpack_require__(336508);
var ContentButtonAnimationStyle_module_default = /*#__PURE__*/__webpack_require__.n(ContentButtonAnimationStyle_module);
// EXTERNAL MODULE: ./src/utils/getDiscountPercentage.js
var getDiscountPercentage = __webpack_require__(153716);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/Carousel/utils.tsx
var utils = __webpack_require__(658619);
// EXTERNAL MODULE: ./src/components/WidgetMaker/utils/buttonConstant.ts
var buttonConstant = __webpack_require__(291850);
// EXTERNAL MODULE: ./src/hooks/useItemClick.js + 1 modules
var useItemClick = __webpack_require__(780058);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/components/utils.ts
var components_utils = __webpack_require__(575646);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/utils/common.js + 9 modules
var common = __webpack_require__(720901);
// EXTERNAL MODULE: ./src/utils/deviceWidth.js
var deviceWidth = __webpack_require__(186812);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/components/Reels/data.ts
var REEL_CONFIGS = {
    FOCUSED_DIMENSIONS: {
        width: 317,
        height: 564
    },
    UNFOCUSED_DIMENSIONS: {
        width: 224,
        height: 400
    },
    COLUMN_GAP_DESKTOP_MODAL: 90
};

// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicDesignsUtilities/ContentAnimationStyles.module.scss
var ContentAnimationStyles_module = __webpack_require__(489429);
var ContentAnimationStyles_module_default = /*#__PURE__*/__webpack_require__.n(ContentAnimationStyles_module);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/CardFrameCollection/utils.ts
var CardFrameCollection_utils = __webpack_require__(290331);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/GlobalCfeLoader.tsx
var GlobalCfeLoader = __webpack_require__(179220);
// EXTERNAL MODULE: ./src/context/WidgetDndContext/index.ts
var WidgetDndContext = __webpack_require__(474151);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/hooks/useLoadVisibleReel.ts
var useLoadVisibleReel = __webpack_require__(50722);
// EXTERNAL MODULE: ./src/utils/checkIsAudioPresentInVideo.ts
var checkIsAudioPresentInVideo = __webpack_require__(5271);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/components/Reels/ReelsMetaData.tsx



























var ReelsVideoSection = /*#__PURE__*/ (0,react.forwardRef)(function Reels(props, videoRef) {
    var pauseVideo = function pauseVideo() {
        var video = videoRef[reelIndex];
        if (!video || video.paused) return;
        try {
            video.pause();
        } catch (err) {
            console.log("Error in pauseVideo:", err);
        }
    };
    var resetVideo = function resetVideo() {
        if (videoRef[reelIndex]) videoRef[reelIndex].currentTime = 0;
    };
    var muteStatus = function muteStatus() {
        if (fromModal && isModalOpen && isThisReelFocused) return shouldMuteVideo;
        return true;
    };
    var ref, ref1, ref2;
    var reelItem = props.reelItem, reelIndex = props.reelIndex, onClick = props.onClick, _fromModal = props.fromModal, fromModal = _fromModal === void 0 ? false : _fromModal, isModalOpen = props.isModalOpen, _customStyle = props.customStyle, customStyle = _customStyle === void 0 ? {} : _customStyle, modalScrolled = props.modalScrolled, _scrollContainerRef = props.scrollContainerRef, scrollContainerRef = _scrollContainerRef === void 0 ? 0 : _scrollContainerRef, callback = props.callback, isMobile = props.isMobile, oneGridCellGeometry = props.oneGridCellGeometry, isBuilder = props.isBuilder, isThisReelFocused = props.isThisReelFocused, cardFrameConfig = props.cardFrameConfig, isLastReel = props.isLastReel, shouldMuteVideo = props.shouldMuteVideo, setShouldMuteVideo = props.setShouldMuteVideo, _isMobileFocusPlayEnabled = props.isMobileFocusPlayEnabled, isMobileFocusPlayEnabled = _isMobileFocusPlayEnabled === void 0 ? false : _isMobileFocusPlayEnabled;
    var ref3 = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), globalStyle = ref3.widgetContextState.globalStyle;
    var mappedProduct = reelItem === null || reelItem === void 0 ? void 0 : (ref = reelItem.mappedProduct) === null || ref === void 0 ? void 0 : ref[0];
    var containerWidth = !isBuilder ? scrollContainerRef === null || scrollContainerRef === void 0 ? void 0 : scrollContainerRef.clientWidth : deviceWidth/* deviceWidth */.o;
    var modalAutoPlayConfig = fromModal ? isThisReelFocused : false;
    var layoutAutoPlayconfig = {
        all: (cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.reelDesktopBehaviour) === "autoPlayAll",
        sequential: (cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.reelDesktopBehaviour) === "autoplayOne",
        onHover: (cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.reelDesktopBehaviour) === "playOnHover"
    };
    var ref4 = (0,react.useState)({
        play: false
    }), autoPlayConfig = ref4[0], setAutoPlayConfig = ref4[1];
    var ref5 = (0,react.useState)(false), isAudioPresentInRawMedia = ref5[0], setIsAudioPresentInRawMedia = ref5[1];
    var ref6 = (0,react.useState)(0), setLoopNumber = ref6[1];
    var ref7 = (0,react.useState)(false), loadVideo = ref7[0], setLoadVideo = ref7[1];
    var ref8 = (0,react.useState)(false), isVideoDownloaded = ref8[0], setIsVideoDownloaded = ref8[1];
    (0,useLoadVisibleReel/* useLoadVisibleReel */.c)({
        videoRef: videoRef,
        reelIndex: reelIndex,
        setLoadVideo: setLoadVideo,
        loadVideo: loadVideo
    });
    (0,react.useEffect)(function() {
        if (isThisReelFocused) {
            var isAudioPresentInRawMedia = (0,checkIsAudioPresentInVideo/* checkIsAudioPresentInVideo */.J)({
                videoRef: videoRef[reelIndex]
            });
            setIsAudioPresentInRawMedia(isAudioPresentInRawMedia);
        }
    }, [
        fromModal,
        isModalOpen,
        isThisReelFocused,
        isMobileFocusPlayEnabled,
        isVideoDownloaded, 
    ]);
    (0,react.useEffect)(function() {
        if (fromModal && !isThisReelFocused) {
            setLoopNumber(0);
        }
    }, [
        isThisReelFocused,
        fromModal
    ]);
    // useEffect(() => {
    //   if (fromModal && loopNumber >= 1) {
    //     callback?.({ currentSelectedReelIdx: isLastReel ? 0 : reelIndex + 1 });
    //   }
    // }, [loopNumber, fromModal, isLastReel, reelIndex]);
    // For desktop this sets the current chosen index
    (0,react.useEffect)(function() {
        if (fromModal) {
            if (!isMobile) {
                var ref;
                var elementRect = (ref = videoRef[reelIndex]) === null || ref === void 0 ? void 0 : ref.getBoundingClientRect();
                var elementPositionFromLeft = isThisReelFocused ? elementRect.left - 20 : elementRect.left - 20;
                if (Math.floor(elementPositionFromLeft) === Math.floor(containerWidth / 2) || Math.floor(elementPositionFromLeft) === Math.ceil(containerWidth / 2) || Math.ceil(elementPositionFromLeft) === Math.floor(containerWidth / 2) || Math.ceil(elementPositionFromLeft) === Math.ceil(containerWidth / 2)) {
                    callback === null || callback === void 0 ? void 0 : callback({
                        currentSelectedReelIdx: reelIndex
                    });
                }
            }
        }
    }, [
        modalScrolled
    ]);
    (0,react.useEffect)(function() {
        if (fromModal && isModalOpen) {
            if (isThisReelFocused) {
                if (isMobile) {
                    scrollContainerRef === null || scrollContainerRef === void 0 ? void 0 : scrollContainerRef.scrollTo({
                        top: scrollContainerRef.clientHeight * reelIndex,
                        behavior: "instant"
                    });
                } else {
                    scrollContainerRef === null || scrollContainerRef === void 0 ? void 0 : scrollContainerRef.scrollTo({
                        left: (REEL_CONFIGS.UNFOCUSED_DIMENSIONS.width + REEL_CONFIGS.COLUMN_GAP_DESKTOP_MODAL) * reelIndex,
                        behavior: "instant"
                    });
                }
                playVideo();
            } else {
                pauseVideo();
            }
        }
        if (!fromModal) {
            if (isModalOpen) {
                pauseVideo();
            } else {
                playVideo();
            }
        }
    }, [
        isThisReelFocused,
        scrollContainerRef,
        isModalOpen,
        fromModal
    ]);
    (0,react.useEffect)(function() {
        if (fromModal) {
            setAutoPlayConfig({
                play: modalAutoPlayConfig
            });
        } else {
            setAutoPlayConfig({
                play: !isModalOpen ? layoutAutoPlayconfig.all || isMobile : false
            });
            if (!isModalOpen) {
                if (layoutAutoPlayconfig.all || isMobile) {
                    if (!isMobileFocusPlayEnabled) playVideo();
                    else isThisReelFocused ? playVideo() : pauseVideo();
                }
            } else {
                isThisReelFocused ? playVideo() : pauseVideo();
            }
            if (layoutAutoPlayconfig.onHover && !isMobile) {
                resetVideo();
                pauseVideo();
            }
        }
    }, [
        isModalOpen, 
    ].concat((0,_to_consumable_array/* default */.Z)(fromModal ? [
        modalAutoPlayConfig
    ] : [
        isThisReelFocused,
        layoutAutoPlayconfig.all,
        layoutAutoPlayconfig.onHover,
        isMobile,
        isMobileFocusPlayEnabled, 
    ])));
    function playVideo() {
        return _playVideo.apply(this, arguments);
    }
    function _playVideo() {
        _playVideo = (0,_async_to_generator/* default */.Z)(function() {
            var video, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        video = videoRef[reelIndex];
                        if (!video || !(video === null || video === void 0 ? void 0 : video.src)) return [
                            2
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            video.play()
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        err = _state.sent();
                        console.log("Error in playVideo:", err);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _playVideo.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()("tw-relative tw-flex-shrink-0 tw-overflow-hidden", !isThisReelFocused && "tw-cursor-pointer", !isThisReelFocused && isModalOpen && "tw-opacity-70"),
        style: (0,_object_spread/* default */.Z)({
            width: "".concat(oneGridCellGeometry === null || oneGridCellGeometry === void 0 ? void 0 : oneGridCellGeometry.width, "px"),
            height: "".concat(oneGridCellGeometry === null || oneGridCellGeometry === void 0 ? void 0 : oneGridCellGeometry.height, "px")
        }, customStyle),
        onMouseEnter: function() {
            if (layoutAutoPlayconfig.onHover && !fromModal) {
                playVideo();
            }
        },
        onMouseLeave: function() {
            if (layoutAutoPlayconfig.onHover && !fromModal) {
                resetVideo();
                pauseVideo();
            }
        },
        onClick: function() {
            if (fromModal && !autoPlayConfig.play) {
                setAutoPlayConfig({
                    play: !autoPlayConfig.play
                });
            // !shouldPlayVideo ? videoRef[reelIndex]?.play() : videoRef[reelIndex]?.pause();
            }
            onClick === null || onClick === void 0 ? void 0 : onClick();
        },
        children: [
            !modalAutoPlayConfig && !!reelItem.thumbnail && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-absolute tw-inset-0 tw-z-[1] tw-h-full tw-w-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: reelItem.thumbnail,
                    className: "tw-h-full tw-w-full tw-object-cover"
                })
            }),
            !isVideoDownloaded && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-absolute tw-left-1/2 tw-top-1/2 tw-z-[4] -tw-translate-x-1/2 -tw-translate-y-1/2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalCfeLoader/* GlobalCfeLoader */.I, {
                    type: (globalStyle === null || globalStyle === void 0 ? void 0 : (ref1 = globalStyle.appLoader) === null || ref1 === void 0 ? void 0 : ref1.loaderId) || "ellipsis",
                    color: globalStyle === null || globalStyle === void 0 ? void 0 : (ref2 = globalStyle.appLoader) === null || ref2 === void 0 ? void 0 : ref2.color
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                ref: function(node) {
                    return videoRef[reelIndex] = node;
                },
                className: classnames_default()("tw-h-full tw-w-full tw-bg-black tw-object-cover", !isMobile || !isMobile && !fromModal && (cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.hoverType) !== "zoomInCard" && (ContentAnimationStyles_module_default())[(0,CardFrameCollection_utils/* getCurrentClass */.WR)(cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.hoverType)]),
                autoPlay: autoPlayConfig.play,
                loop: true,
                muted: muteStatus(),
                playsInline: true,
                onLoadedData: function() {
                    return setIsVideoDownloaded(true);
                },
                src: loadVideo ? reelItem.reelUrl : undefined,
                onSeeked: function() {
                    if (videoRef[reelIndex].currentTime === 0) {
                        setLoopNumber(function(c) {
                            return c + 1;
                        });
                    }
                },
                onTimeUpdate: function(e) {
                    if (!fromModal && !isModalOpen) {
                        if (e.currentTarget.currentTime >= 4) {
                            if (layoutAutoPlayconfig.all) {
                                resetVideo();
                                playVideo();
                            }
                            if (layoutAutoPlayconfig.sequential) {
                                callback === null || callback === void 0 ? void 0 : callback({
                                    currentSelectedReelIdx: isLastReel || !reelIndex ? reelIndex : reelIndex + 1
                                });
                            }
                        }
                    }
                }
            }),
            isAudioPresentInRawMedia && !!fromModal && isThisReelFocused && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: function() {
                    return setShouldMuteVideo(function(v) {
                        return !v;
                    });
                },
                className: classnames_default()("tw-pointer wb-sprite tw-absolute  tw-right-[12px] tw-z-[4]", !shouldMuteVideo ? "mute-lg" : "unmute-lg", mappedProduct ? "tw-bottom-[126px]" : "tw-bottom-[24px]")
            })
        ]
    });
});
function ReelsMetaData(param) {
    var reelItem = param.reelItem, isMobile = param.isMobile, _fromModal = param.fromModal, fromModal = _fromModal === void 0 ? false : _fromModal, cardFrameConfig = param.cardFrameConfig, _layoutName = param.layoutName, layoutName = _layoutName === void 0 ? "" : _layoutName, _addPadding = param.addPadding, addPadding = _addPadding === void 0 ? true : _addPadding, _listPresentationConfig = param.listPresentationConfig, listPresentationConfig = _listPresentationConfig === void 0 ? {} : _listPresentationConfig;
    var ref;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useItemClick/* useItemClick */.M)(), 1), onItemClick = ref1[0];
    var mappedProduct = reelItem === null || reelItem === void 0 ? void 0 : (ref = reelItem.mappedProduct) === null || ref === void 0 ? void 0 : ref[0];
    var productNameSize = (0,components_utils/* getMappedproductsTextSize */.Im)(!isMobile ? cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.productNameSize : cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.productNameSizeMobile);
    var productPriceSize = (0,components_utils/* getMappedproductsTextSize */.Im)(!isMobile ? cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.productPriceSize : cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.productPriceSizeMobile);
    var productNameCasing = (0,components_utils/* getMappedProductCasing */.TI)(cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.productNameTextCase);
    var productNameTextAlign = (0,components_utils/* getMappedProductTextAlign */.sz)(cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.textAlign);
    var productNameThickness = (0,components_utils/* getMappedProductTextThickness */.aA)(cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.productNameThincness);
    var productPriceThickness = (0,components_utils/* getMappedProductTextThickness */.aA)(cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.productPriceThincness);
    var productPriceCasing = (0,components_utils/* getMappedProductCasing */.TI)(cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.productPriceTextCase);
    var discount = (0,getDiscountPercentage/* getDiscountPercentage */.$)(mappedProduct === null || mappedProduct === void 0 ? void 0 : mappedProduct.price, mappedProduct === null || mappedProduct === void 0 ? void 0 : mappedProduct.discounted_price);
    var navigateToPdp = function() {
        return onItemClick(mappedProduct);
    };
    // For inside the modal reels
    if (fromModal && mappedProduct) {
        var ref2;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-px-[8px] tw-pb-[8px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "imgWrapperGlobalStyle globalImgStyleConsumer tw-flex tw-cursor-pointer tw-items-center tw-gap-[12px] tw-bg-white/[0.7] tw-p-[12px]",
                onClick: navigateToPdp,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "imgWrapperGlobalStyle globalImgStyleConsumer tw-h-[58px] tw-w-[58px] tw-flex-shrink-0 tw-border-[1.42px] tw-border-solid tw-border-[#ffffff]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: mappedProduct === null || mappedProduct === void 0 ? void 0 : mappedProduct.image_url,
                            className: "tw-object-cover"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-flex tw-flex-col",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "tw-m-0 tw-line-clamp-2 tw-break-words tw-leading-[16px]",
                                style: (0,_object_spread/* default */.Z)({
                                    color: cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.productNameColor
                                }, productNameSize, productNameThickness, productNameCasing),
                                children: mappedProduct === null || mappedProduct === void 0 ? void 0 : mappedProduct.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()("pricingSection tw-mt-[6px] tw-flex tw-flex-wrap tw-items-center tw-gap-x-[8px] tw-gap-y-[6px]"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "pricingSection tw-flex tw-flex-wrap tw-items-end tw-gap-x-[4px] tw-gap-y-[6px]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "tw-relative tw-m-0 tw-text-[11.4px] tw-leading-[0.88] tw-text-newBlack",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: paymentLinks/* CURRENT_CURRENCY_SYMBOL */.bZ
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: (0,formatPricing/* formatPriceToINR */.e)(mappedProduct === null || mappedProduct === void 0 ? void 0 : mappedProduct.discounted_price)
                                                    })
                                                ]
                                            }),
                                            (mappedProduct === null || mappedProduct === void 0 ? void 0 : mappedProduct.discounted_price) !== (mappedProduct === null || mappedProduct === void 0 ? void 0 : mappedProduct.price) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                // style={{ color: hexToRgba(overrideStyles?.textColor || config.productPriceColor,0.6), ...productActualPriceStyles.style,}}
                                                className: "tw-m-0 tw-text-[11.4px] tw-leading-[0.88] tw-text-newBlack/[0.6] tw-line-through",
                                                children: [
                                                    paymentLinks/* CURRENT_CURRENCY_SYMBOL */.bZ,
                                                    (0,formatPricing/* formatPriceToINR */.e)(mappedProduct === null || mappedProduct === void 0 ? void 0 : mappedProduct.price)
                                                ]
                                            }) : null
                                        ]
                                    }),
                                    !!discount && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        // style={{ background:config?.discountStyle !== 'text' && config?.backgroundColor,color: config?.textColor,}}
                                        className: classnames_default()("tw-m-0 tw-break-keep tw-px-[4px] tw-py-[2px] tw-text-center tw-text-[10.45px] tw-font-medium tw-leading-[1] ", "tw-bg-[#2CA861] tw-text-[#ffffff]"),
                                        children: "".concat(discount, "% OFF")
                                    })
                                ]
                            })
                        ]
                    }),
                    cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : (ref2 = cardFrameConfig.buttonConfig) === null || ref2 === void 0 ? void 0 : ref2.map(function(buttonData, btnIndex) {
                        var ref, ref1;
                        // const overlayTextStyles: any = getOverlayTextStyles(cardFrameConfig, buttonData);
                        var buttonVariant = (0,utils/* getButtonVariantsData */.Tk)(buttonData, false);
                        var selectedButtonType = buttonVariant[buttonData.type];
                        // const isBtnSolid = buttonData.type === BUTTON_TYPE.SOLID;
                        var isBtnTextual = buttonData.type === buttonConstant/* BUTTON_TYPE.TEXTUAL */.JB.TEXTUAL;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            btnType: buttonData.type,
                            onClick: navigateToPdp,
                            buttonData: buttonData,
                            selectedButtonData: selectedButtonType,
                            variant: selectedButtonType.variant,
                            disableHoverAnimation: isMobile,
                            className: classnames_default()("addToCtaButtonForProduct !tw-pointer-events-auto !tw-ml-auto !tw-max-h-[28px] !tw-min-w-[auto] tw-cursor-pointer !tw-font-medium", "!tw-w-max", !isBtnTextual ? "!tw-p-[6px]" : "!tw-p-0", // disable animations
                            !(buttonData === null || buttonData === void 0 ? void 0 : (ref = buttonData.buttonAnimationConfig) === null || ref === void 0 ? void 0 : ref.classKey) ? "[&_p]:before:!tw-hidden" : !isMobile && (ContentButtonAnimationStyle_module_default())[buttonData === null || buttonData === void 0 ? void 0 : (ref1 = buttonData.buttonAnimationConfig) === null || ref1 === void 0 ? void 0 : ref1.classKey]),
                            textWrapperClass: classnames_default()("!tw-w-full !tw-text-[12px] !tw-relative !tw-flex !tw-justify-center tw-break-keep tw-whitespace-nowrap"),
                            children: buttonData === null || buttonData === void 0 ? void 0 : buttonData.text
                        }, btnIndex);
                    })
                ]
            })
        });
    }
    // For widget layout reels
    switch(layoutName){
        case "layout2":
        case "layout3":
            return !!mappedProduct && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                onClick: navigateToPdp,
                className: classnames_default()("removeGlobalOverride imgWrapperGlobalStyle addBottomLeftGlobalRadius addBottomRightGlobalRadius globalImgStyleConsumer tw-flex tw-w-full tw-flex-grow tw-cursor-pointer tw-flex-col tw-items-center tw-bg-[#ffffff]", addPadding && (isMobile ? "tw-px-[10px] tw-pb-[11px]" : "tw-px-[14px] tw-pb-[15px]")),
                style: {
                    background: listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.backgroundColor
                },
                children: [
                    layoutName !== "layout3" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        onClick: navigateToPdp,
                        className: "imgWrapperGlobalStyle globalImgStyleConsumer tw-relative tw-top-[-40px] tw-h-[58px] tw-w-[58px] tw-cursor-pointer tw-border-[1.42px] tw-border-solid tw-border-[#ffffff]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: mappedProduct === null || mappedProduct === void 0 ? void 0 : mappedProduct.image_url,
                            className: "tw-object-cover"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()("tw-flex tw-w-full tw-flex-col", (cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.textAlign) === "center" && "tw-items-center", layoutName !== "layout3" ? "tw-mt-[-30px]" : "tw-mt-[16px]"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "tw-m-0 tw-line-clamp-2 tw-leading-[20px]",
                                style: (0,_object_spread/* default */.Z)({
                                    color: cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.productNameColor
                                }, productNameSize, productNameTextAlign, productNameThickness, productNameCasing),
                                children: mappedProduct === null || mappedProduct === void 0 ? void 0 : mappedProduct.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()("pricingSection tw-mt-[8px] tw-flex tw-flex-wrap tw-items-center tw-gap-x-[8px] tw-gap-y-[6px]", (cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.textAlign) === "center" && "tw-justify-center"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "pricingSection tw-flex tw-flex-wrap tw-items-end tw-gap-x-[4px] tw-gap-y-[6px]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "tw-relative tw-bottom-[-0.5px] tw-m-0 tw-leading-[0.88]",
                                                style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                    color: cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.productPriceColor
                                                }, productPriceSize, productNameTextAlign, productPriceThickness, productPriceCasing), {
                                                    lineHeight: 0.88
                                                }),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: paymentLinks/* CURRENT_CURRENCY_SYMBOL */.bZ
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: (0,formatPricing/* formatPriceToINR */.e)(mappedProduct === null || mappedProduct === void 0 ? void 0 : mappedProduct.discounted_price)
                                                    })
                                                ]
                                            }),
                                            (mappedProduct === null || mappedProduct === void 0 ? void 0 : mappedProduct.discounted_price) !== (mappedProduct === null || mappedProduct === void 0 ? void 0 : mappedProduct.price) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                    color: (0,common/* hexToRgba */.a7)(cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.productPriceColor, 0.6)
                                                }, productPriceSize, productNameTextAlign, productPriceThickness), {
                                                    lineHeight: 0.88
                                                }),
                                                className: "tw-m-0 tw-text-[11.4px] tw-leading-[0.88] tw-text-newBlack/[0.6] tw-line-through",
                                                children: [
                                                    paymentLinks/* CURRENT_CURRENCY_SYMBOL */.bZ,
                                                    (0,formatPricing/* formatPriceToINR */.e)(mappedProduct === null || mappedProduct === void 0 ? void 0 : mappedProduct.price)
                                                ]
                                            }) : null
                                        ]
                                    }),
                                    !!discount && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        // style={{ background:config?.discountStyle !== 'text' && config?.backgroundColor,color: config?.textColor,}}
                                        className: classnames_default()("tw-m-0 tw-break-keep tw-px-[4px] tw-py-[2px] tw-text-center tw-text-[10.45px] tw-font-medium tw-leading-[1] ", "tw-bg-[#2CA861] tw-text-[#ffffff]"),
                                        children: "".concat(discount, "% OFF")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            });
        case "layout4":
            if (reelItem === null || reelItem === void 0 ? void 0 : reelItem.description) {
                var descSize = (0,components_utils/* getMappedproductsTextSize */.Im)(!isMobile ? cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.descriptionSize : cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.descriptionSizeMobile);
                var descTextAlign = (0,components_utils/* getMappedProductTextAlign */.sz)(cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.descriptionTextAlign);
                var descThickness = (0,components_utils/* getMappedProductTextThickness */.aA)(cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.descriptionThicness);
                var descCasing = (0,components_utils/* getMappedProductCasing */.TI)(cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.descriptionTextCase);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-mt-[16px] tw-bg-[#FFFFFF]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: classnames_default()("tw-m-0 tw-w-full", addPadding && (isMobile ? "tw-px-[10px] tw-pb-[18px]" : "tw-px-[14px] tw-pb-[15px]")),
                        style: (0,_object_spread/* default */.Z)({
                            color: cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.descriptionColor
                        }, descSize, descTextAlign, descThickness, descCasing),
                        children: reelItem === null || reelItem === void 0 ? void 0 : reelItem.description
                    })
                });
            } else return null;
        default:
            return null;
    }
}

// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/Carousel/components/Arrows/index.tsx + 1 modules
var Arrows = __webpack_require__(601523);
// EXTERNAL MODULE: ./node_modules/@mui/material/Modal/Modal.js + 4 modules
var Modal = __webpack_require__(496664);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/hooks/useDisableScroll.ts
var useDisableScroll = __webpack_require__(335964);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/hooks/useDisableRootDoc.ts

function useDisableRootDoc(param) {
    var scrollRef = param.scrollRef, openModal = param.openModal, isMobile = param.isMobile, setScreenHeight = param.setScreenHeight, _disableDoc = param.disableDoc, disableDoc = _disableDoc === void 0 ? false : _disableDoc;
    (0,react.useEffect)(function() {
        if (isMobile) {
            setScreenHeight(window.innerHeight);
            var htmlElement = document.getElementsByTagName("html")[0];
            var bodyElement = document.getElementsByTagName("body")[0];
            var onResize = function() {
                setScreenHeight(window.innerHeight);
            };
            var modifyHtmlCustomStyles = function(addCustomStyles) {
                if (!htmlElement || !bodyElement) return;
                if (!addCustomStyles) {
                    htmlElement.style.overflowY = "";
                    htmlElement.style.position = "";
                    htmlElement.style.width = "";
                    htmlElement.style.height = "";
                    htmlElement.style.overscrollBehaviorY = "";
                    bodyElement.style.overflowY = "";
                    bodyElement.style.width = "";
                    bodyElement.style.overscrollBehaviorY = "";
                    bodyElement.style.height = "";
                } else {
                    htmlElement.style.overflowY = "hidden";
                    htmlElement.style.position = "fixed";
                    htmlElement.style.width = "100%";
                    htmlElement.style.overscrollBehaviorY = "none";
                    htmlElement.style.height = "100%";
                    htmlElement.style.maxHeight = "100%";
                    bodyElement.style.overflowY = "hidden";
                    bodyElement.style.width = "100%";
                    bodyElement.style.overscrollBehaviorY = "none";
                    bodyElement.style.height = "100%";
                    bodyElement.style.maxHeight = "100%";
                }
            };
            if (openModal) {
                disableDoc && modifyHtmlCustomStyles(true);
                window.addEventListener("resize", onResize);
            }
            if (!openModal) {
                disableDoc && modifyHtmlCustomStyles(false);
                window.removeEventListener("resize", onResize);
            }
            return function() {
                disableDoc && modifyHtmlCustomStyles(false);
            };
        }
    }, [
        scrollRef,
        openModal,
        isMobile
    ]);
    return null;
}

// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ProductCard/utils.tsx + 1 modules
var ProductCard_utils = __webpack_require__(881241);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/context/ListPresentationContext.tsx + 15 modules
var ListPresentationContext = __webpack_require__(101657);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/components/Reels/Reels.tsx







// import { getReelCardConfigs } from '../utils';










/**
 * Notes: 1. Scroll to selected reel is done from video reel component, which calculates the positioning & scrolls the
 *            reel to the center
 * 2. In Desktop, padding is put in scroll container horizontally to put the first & last videos at the center
 * */ // to hit when scroll has ended
var scrollTrackTimer = null;
var currentFocusedReelIndex = 0;
function Reels() {
    var onArrowSlideClick = function onArrowSlideClick(direction) {
        setCurrentFocusedReel(function(idx) {
            return idx === (reels === null || reels === void 0 ? void 0 : reels.length) - 1 && direction === "to-right" || idx === 0 && direction === "to-left" ? idx : direction === "to-right" ? idx + 1 : idx - 1;
        });
    };
    var _RenderReelsModalBody = // For Modal
    function _RenderReelsModalBody() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReelsViewportWrapper, {
            isMobile: isMobile,
            mobileHeight: screenHeight,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("tw-fixed tw-z-[10000] tw-mx-auto tw-flex tw-w-full tw-max-w-[1400px] tw-justify-end", isMobile ? "tw-right-[12px] tw-top-[12px]" : "tw-right-[36px] tw-top-[36px]"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        onClick: handleModalClose,
                        className: classnames_default()("ic-cross-bg-black-lg wb-sprite  tw-rounded-3xl tw-shadow-[0px_4px_4px_#00000040]")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Arrows/* ArrowCouple */.l, {
                    isVisible: !isMobile && (scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.scrollWidth) > (scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.clientWidth),
                    className: "tw-left-[50%] -tw-translate-x-1/2 md:tw-max-w-[1100px] md:!tw-px-[40px] lg:md:!tw-px-0" // lg:tw-max-w-[980px] xl:tw-max-w-[1080px] xxl:tw-max-w-[1180px]
                    ,
                    handlePrevClick: function() {
                        return onArrowSlideClick("to-left");
                    },
                    handleNextClick: function() {
                        return onArrowSlideClick("to-right");
                    },
                    imageProps: {
                        bgColor: "#ffffff",
                        bgOpacity: 1,
                        arrowColor: "#000000",
                        height: 48,
                        width: 48
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ReelsListWrapper, {
                    columnGap: REEL_CONFIGS.COLUMN_GAP_DESKTOP_MODAL,
                    maxWidth: !isMobile ? "800px" : "100vw",
                    ref: setCallbackScrollRef,
                    className: "no-scrollbar",
                    onScroll: handleScroll,
                    mobileHeight: screenHeight,
                    onTouchStart: function() {
                    // if (isMobile) {
                    //   if (scrollTrackTimer) clearTimeout(scrollTrackTimer);
                    // }
                    },
                    onTouchEnd: function() {
                    // if (isMobile) {
                    //   scrollTrackTimer = setTimeout(() => {
                    //     currentFocusedReelIndex = scrollRef?.scrollTop / screenHeight;
                    //     scrollRef?.scrollTo({
                    //       top: screenHeight * Math.round(currentFocusedReelIndex),
                    //       behavior: 'instant',
                    //     });
                    //     setCurrentFocusedReel(Math.round(currentFocusedReelIndex));
                    //     clearTimeout(scrollTrackTimer);
                    //     scrollTrackTimer = null;
                    //   }, 180);
                    // }
                    },
                    children: reels.map(function(reelItem, reelIdx) {
                        var ref, ref1;
                        var isThisReelFocused = reelIdx === currentFocusedReel;
                        var cardGeometry = isThisReelFocused ? REEL_CONFIGS.FOCUSED_DIMENSIONS : REEL_CONFIGS.UNFOCUSED_DIMENSIONS;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReelItem, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cardGeometry), {
                            mobileHeight: screenHeight,
                            borderRadius: globalStyle === null || globalStyle === void 0 ? void 0 : (ref = globalStyle.imageCards) === null || ref === void 0 ? void 0 : (ref1 = ref.style) === null || ref1 === void 0 ? void 0 : ref1.borderRadius,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ReelsVideoSection, {
                                    isThisReelFocused: isThisReelFocused,
                                    scrollContainerRef: scrollRef,
                                    isModalOpen: openModal,
                                    ref: videoRefs,
                                    isBuilder: isBuilder,
                                    fromModal: true,
                                    cardFrameConfig: cardFrameConfig,
                                    reelIndex: reelIdx,
                                    reelItem: reelItem,
                                    isLastReel: reelIdx === (reels === null || reels === void 0 ? void 0 : reels.length) - 1,
                                    oneGridCellGeometry: cardGeometry,
                                    customStyle: isMobile ? {
                                        width: "100%",
                                        height: "100%"
                                    } : undefined,
                                    onClick: function() {
                                        return setCurrentFocusedReel(reelIdx);
                                    },
                                    modalScrolled: modalScrolled,
                                    isMobile: isMobile,
                                    shouldMuteVideo: shouldMuteVideo,
                                    setShouldMuteVideo: setShouldMuteVideo,
                                    callback: function(param) {
                                        var currentSelectedReelIdx = param.currentSelectedReelIdx;
                                        if (typeof currentSelectedReelIdx === "number") {
                                            setCurrentFocusedReel(currentSelectedReelIdx);
                                        }
                                    }
                                }),
                                (!!isMobile || !isMobile && isThisReelFocused) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReelsMetaData, {
                                    fromModal: true,
                                    reelItem: reelItem,
                                    isMobile: isMobile,
                                    cardFrameConfig: cardFrameConfig
                                })
                            ]
                        }), reelIdx);
                    })
                })
            ]
        });
    };
    var ref = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), _widgetContextState = ref.widgetContextState, globalStyle = _widgetContextState.globalStyle, isBuilder = _widgetContextState.isBuilder;
    var data = (0,ListPresentationContext/* useListPresentationContextData */.ds)();
    var _state = data.state, isMobile = _state.isMobile, listPresentationConfig = _state.listPresentationConfig, cardFrameConfig = _state.cardFrameConfig;
    var getConfigsAndUtils = data.utilities.getConfigsAndUtils;
    var _generalValues = getConfigsAndUtils().generalValues, oneGridCellGeometry = _generalValues.oneGridCellGeometry, featuredReelConfigs = _generalValues.featuredReelConfigs, carouselIndicatorConfigs = _generalValues.carouselIndicatorConfigs;
    var reelsData = cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.reelsData;
    var layoutName = listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.layoutName;
    var videoRefs = (0,react.useRef)({});
    var ref1 = (0,react.useState)(null), scrollRef = ref1[0], setScrollRef = ref1[1];
    var ref2 = (0,react.useState)(false), openModal = ref2[0], setOpenModal = ref2[1];
    var ref3 = (0,react.useState)(false), modalScrolled = ref3[0], setModalScrolled = ref3[1]; // This will be toggled
    var ref4 = (0,react.useState)(0), currentFocusedReel = ref4[0], setCurrentFocusedReel = ref4[1];
    var ref5 = (0,react.useState)(0), screenHeight = ref5[0], setScreenHeight = ref5[1];
    var ref6 = (0,react.useState)(false), shouldMuteVideo = ref6[0], setShouldMuteVideo = ref6[1];
    var reels = (reelsData === null || reelsData === void 0 ? void 0 : reelsData.filter(function(reelItem) {
        return reelItem.isVisible === undefined || reelItem.isVisible;
    })) || [];
    var cardWrapperConfigs = (0,ProductCard_utils/* getCartWrapperConfigs */.Ui)(listPresentationConfig);
    (0,useDisableScroll/* default */.Z)({
        isMobile: isMobile,
        scrollRef: scrollRef
    });
    useDisableRootDoc({
        scrollRef: scrollRef,
        openModal: openModal,
        isMobile: isMobile,
        setScreenHeight: setScreenHeight
    });
    (0,react.useEffect)(function() {
        if (!openModal) {
            setCurrentFocusedReel(0);
            scrollTrackTimer = null;
            currentFocusedReelIndex = 0;
        }
        return function() {
            scrollTrackTimer = null;
            currentFocusedReelIndex = 0;
        };
    }, [
        currentFocusedReel,
        openModal
    ]);
    // useEffect(() => {
    //   if (!isMobile) {
    //     console.log('currentFocusedReelIndex:  ', currentFocusedReelIndex);
    //     setCurrentFocusedReel(Math.ceil(currentFocusedReelIndex));
    //   }
    // }, [modalScrolled]);
    var handleModalOpen = function() {
        return setOpenModal(true);
    };
    var handleModalClose = function() {
        return setOpenModal(false);
    };
    var setCallbackScrollRef = (0,react.useCallback)(function(node) {
        if (!node) return;
        setScrollRef(node);
    }, []);
    var handleScroll = function() {
        if (!isMobile) {
        // const scrollPosition = scrollRef?.scrollLeft;
        // currentFocusedReelIndex = scrollPosition / REEL_WIDTH;
        }
        // This snaps the video component on the screen vertical edges, works when touch device is used
        if (isMobile) {
            if (scrollTrackTimer) {
                clearTimeout(scrollTrackTimer);
                scrollTrackTimer = null;
            }
            currentFocusedReelIndex = (scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.scrollTop) / screenHeight;
            scrollTrackTimer = setTimeout(function() {
                scrollTrackTimer = null;
                scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.scrollTo({
                    top: screenHeight * Math.round(currentFocusedReelIndex)
                });
                setCurrentFocusedReel(Math.round(currentFocusedReelIndex));
            }, 130);
        } else {
            if (scrollTrackTimer) {
                clearTimeout(scrollTrackTimer);
                scrollTrackTimer = null;
            }
            // const intialHeadStart = window.innerWidth / 1 - 45;
            currentFocusedReelIndex = (scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.scrollLeft) / ((REEL_CONFIGS.FOCUSED_DIMENSIONS.width + REEL_CONFIGS.UNFOCUSED_DIMENSIONS.width) / 2 + 90);
            scrollTrackTimer = setTimeout(function() {
                setModalScrolled(function(v) {
                    return !v;
                });
            }, 130);
        // scrollTrackTimer = setTimeout(() => {
        //   scrollTrackTimer = null;
        //   setCurrentFocusedReel(Math.round(currentFocusedReelIndex));
        // }, 130);
        }
    };
    // Shown as in page layout, no in modal
    var calculateReelLayoutDimension = function() {
        var initialWidth = oneGridCellGeometry === null || oneGridCellGeometry === void 0 ? void 0 : oneGridCellGeometry.width;
        if (cardWrapperConfigs.isCardLayout) {
            if (cardWrapperConfigs.isFullWidth) {
                initialWidth -= 2; // remove horizontal border width
            } else {
                // remove horizontal padding
                if (isMobile) initialWidth -= 20;
                else initialWidth -= 28;
            }
        }
        return {
            width: initialWidth,
            height: oneGridCellGeometry === null || oneGridCellGeometry === void 0 ? void 0 : oneGridCellGeometry.height
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            reels === null || reels === void 0 ? void 0 : reels.map(function(reelItem, reelIdx) {
                // Mobile only: As this is on layout not in modal, column is set to one
                var isThisReelFocused = reelIdx * 2 === Math.floor(carouselIndicatorConfigs.scrollPercentage / reels.length) - 2 || reelIdx + 1 === 1 && Math.floor(carouselIndicatorConfigs.scrollPercentage / reels.length) - 2 === 1 || (reelIdx + 1) * 2 + 1 === Math.floor(carouselIndicatorConfigs.scrollPercentage / reels.length);
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()("imgWrapperGlobalStyle globalImgStyleConsumer tw-relative tw-flex tw-flex-shrink-0 tw-snap-center tw-flex-col tw-overflow-hidden", cardWrapperConfigs.isCardLayout && "tw-border-[1px] tw-border-solid", cardWrapperConfigs.isCardLayout && !cardWrapperConfigs.isFullWidth && (isMobile ? "tw-px-[10px] tw-py-[10px]" : "tw-px-[14px] tw-py-[14px]"), !isMobile && (cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.hoverType) === "zoomInCard" && (ContentAnimationStyles_module_default())[(0,CardFrameCollection_utils/* getCurrentClass */.WR)(cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.hoverType)], featuredReelConfigs.expandFocusedReel && isMobile && isThisReelFocused && "tw-scale-[1.1] tw-duration-500"),
                    style: {
                        width: "".concat(oneGridCellGeometry === null || oneGridCellGeometry === void 0 ? void 0 : oneGridCellGeometry.width, "px"),
                        borderColor: listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.borderColor
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ReelsVideoSection, {
                            ref: videoRefs,
                            isThisReelFocused: isThisReelFocused,
                            isBuilder: isBuilder,
                            reelItem: reelItem,
                            isMobile: isMobile,
                            isLastReel: reelItem === (reels === null || reels === void 0 ? void 0 : reels.length) - 1,
                            reelIndex: reelIdx,
                            isModalOpen: openModal,
                            cardFrameConfig: cardFrameConfig,
                            isMobileFocusPlayEnabled: featuredReelConfigs.expandFocusedReel,
                            oneGridCellGeometry: calculateReelLayoutDimension(),
                            onClick: function() {
                                setCurrentFocusedReel(reelIdx);
                                handleModalOpen();
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ReelsMetaData, {
                            reelItem: reelItem,
                            isMobile: isMobile,
                            cardFrameConfig: cardFrameConfig,
                            layoutName: layoutName,
                            addPadding: cardWrapperConfigs.isCardLayout && cardWrapperConfigs.isFullWidth,
                            listPresentationConfig: listPresentationConfig
                        })
                    ]
                }, reelIdx);
            }),
            !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                open: openModal,
                onClose: handleModalClose,
                "aria-labelledby": "modal-modal-title",
                "aria-describedby": "modal-modal-description",
                children: _RenderReelsModalBody()
            }) : openModal && _RenderReelsModalBody()
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/components/Reels/index.ts



/***/ }),

/***/ 575646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Im": function() { return /* binding */ getMappedproductsTextSize; },
/* harmony export */   "Ju": function() { return /* binding */ commonApiHeader; },
/* harmony export */   "TI": function() { return /* binding */ getMappedProductCasing; },
/* harmony export */   "aA": function() { return /* binding */ getMappedProductTextThickness; },
/* harmony export */   "sz": function() { return /* binding */ getMappedProductTextAlign; }
/* harmony export */ });
/* unused harmony export getTextSizeNum */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(667294);

function getMappedproductsTextSize(sizeString) {
    var style = {};
    switch(sizeString){
        case "extraSmall":
            style.fontSize = "12px";
            style.lineHeight = "1.4";
            break;
        case "small":
            style.fontSize = "13px";
            style.lineHeight = "1.4";
            break;
        case "regular":
            style.fontSize = "14px";
            style.lineHeight = "1.4";
            break;
        case "medium":
            style.fontSize = "16px";
            style.lineHeight = "1.4";
            break;
        case "large":
            style.fontSize = "18px";
            style.lineHeight = "1.4";
            break;
        case "extraLarge":
            style.fontSize = "20px";
            style.lineHeight = "1.4";
            break;
        default:
            style.fontSize = "14px";
            style.lineHeight = "1.4";
            break;
    }
    return style;
}
function getMappedProductTextAlign(xAlignment) {
    var styles = {};
    switch(xAlignment){
        case "left":
            styles.textAlign = "left";
            break;
        case "center":
            styles.textAlign = "center";
            break;
        case "right":
            styles.textAlign = "right";
            break;
    }
    return styles;
}
function getMappedProductTextThickness(textThicness) {
    var styles = {};
    switch(textThicness){
        case "thin":
            styles.fontWeight = "300";
            break;
        case "regular":
            styles.fontWeight = "400";
            break;
        case "medium":
            styles.fontWeight = "500";
            break;
        case "semiBold":
            styles.fontWeight = "600";
            break;
        case "bold":
            styles.fontWeight = "700";
            break;
        default:
            styles.fontWeight = "400";
            break;
    }
    return styles;
}
function getMappedProductCasing(titleTextCase) {
    var style = {};
    switch(titleTextCase){
        case "none":
            style.textTransform = "none";
            break;
        case "capitalize":
            style.textTransform = "capitalize";
            break;
        case "uppercase":
            style.textTransform = "uppercase";
            break;
    }
    return style;
}
function getTextSizeNum(sizeString) {
    var textSizeStr = getMappedproductsTextSize(sizeString).fontSize;
    return Number(textSizeStr.replace("px", ""));
}
function commonApiHeader(authToken) {
    return {
        headers: {
            auth_token: authToken,
            app_os: "cfe",
            app_version: "0.1.0",
            "Content-Type": "application/json"
        }
    };
}


/***/ }),

/***/ 335964:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useDisableScroll; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(667294);

function useDisableScroll(param) {
    var _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile, scrollRef = param.scrollRef, _disableScroll = param.disableScroll, disableScroll = _disableScroll === void 0 ? true : _disableScroll;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!isMobile && scrollRef && disableScroll) {
            var scrollLock = function(event) {
                event.preventDefault();
                event.stopPropagation();
            };
            scrollRef.addEventListener("wheel", scrollLock);
            return function() {
                scrollRef.addEventListener("wheel", scrollLock);
            };
        }
    }, [
        scrollRef
    ]);
    return null;
}


/***/ }),

/***/ 50722:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ useLoadVisibleReel; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(667294);

function useLoadVisibleReel(param) {
    var videoRef = param.videoRef, reelIndex = param.reelIndex, setLoadVideo = param.setLoadVideo, loadVideo = param.loadVideo;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (videoRef[reelIndex]) {
            var loadMoreCallback = function(entries, observer) {
                entries.forEach(function(entry) {
                    if (entry.isIntersecting) {
                        setLoadVideo(true);
                        observer.unobserve(entry.target);
                    }
                });
            };
            var observer;
            if (!loadVideo) {
                observer = new IntersectionObserver(loadMoreCallback, {
                    root: null,
                    rootMargin: "0px",
                    threshold: 0.01
                });
                observer.observe(videoRef[reelIndex]);
            } else {
                observer === null || observer === void 0 ? void 0 : observer.unobserve(videoRef[reelIndex]);
            }
            return function() {
                videoRef[reelIndex] && (observer === null || observer === void 0 ? void 0 : observer.unobserve(videoRef[reelIndex]));
            };
        }
    }, []);
    return null;
}


/***/ }),

/***/ 179220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ GlobalCfeLoader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var _globalLoader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(325480);


var GlobalCfeLoader = function(param) {
    var type = param.type, color = param.color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_globalLoader__WEBPACK_IMPORTED_MODULE_1__/* .GlobalLoader */ .k, {
        type: type,
        color: color
    });
};


/***/ }),

/***/ 325480:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ GlobalLoader; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(626042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var _globalLoader_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(185134);
/* harmony import */ var _globalLoader_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_globalLoader_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var tailwind_merge__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(798388);
/* harmony import */ var src_redux_ssrStore__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(326706);
/* harmony import */ var src_components_Common_LoaderIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(965700);







var GlobalLoader = function(props) {
    var type = props.type, color = props.color;
    var store = (0,src_redux_ssrStore__WEBPACK_IMPORTED_MODULE_2__/* .useSSRSelector */ .kF)(function(state) {
        return state.storeReducer.store;
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        document.documentElement.style.setProperty("--loader-color", color);
    }, [
        color
    ]);
    switch(type){
        case "logo1":
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_4__/* .twMerge */ .m6)((_globalLoader_module_scss__WEBPACK_IMPORTED_MODULE_5___default().logo1)),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: store.logo_image,
                        style: {
                            height: "35px",
                            width: "35px"
                        }
                    })
                });
            }
        case "logo2":
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_4__/* .twMerge */ .m6)((_globalLoader_module_scss__WEBPACK_IMPORTED_MODULE_5___default().logo2)),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: store.logo_image,
                        style: {
                            height: "35px",
                            width: "35px"
                        }
                    })
                });
            }
        case "loader1":
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                    version: "1.1",
                    id: "L9",
                    xmlns: "http://www.w3.org/2000/svg",
                    x: "0px",
                    y: "0px",
                    width: "65px",
                    height: "65px",
                    viewBox: "0 0 100 100",
                    enableBackground: "new 0 0 0 0",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: color,
                        d: "M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animateTransform", {
                            attributeName: "transform",
                            attributeType: "XML",
                            type: "rotate",
                            dur: "1s",
                            from: "0 50 50",
                            to: "360 50 50",
                            repeatCount: "indefinite"
                        })
                    })
                });
            }
        case "loader2":
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                    version: "1.1",
                    id: "L5",
                    xmlns: "http://www.w3.org/2000/svg",
                    x: "0px",
                    y: "0px",
                    width: "35px",
                    height: "35px",
                    viewBox: "-20 0 100 100",
                    enableBackground: "new 0 0 0 0",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            fill: color,
                            stroke: "none",
                            cx: "6",
                            cy: "50",
                            r: "6",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 15 ; 0 -15; 0 15",
                                repeatCount: "indefinite",
                                begin: "0.1"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            fill: color,
                            stroke: "none",
                            cx: "30",
                            cy: "50",
                            r: "6",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 10 ; 0 -10; 0 10",
                                repeatCount: "indefinite",
                                begin: "0.2"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            fill: color,
                            stroke: "none",
                            cx: "54",
                            cy: "50",
                            r: "6",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 5 ; 0 -5; 0 5",
                                repeatCount: "indefinite",
                                begin: "0.3"
                            })
                        })
                    ]
                });
            }
        case "loader3":
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_4__/* .twMerge */ .m6)((_globalLoader_module_scss__WEBPACK_IMPORTED_MODULE_5___default().loader3), "tw-h-[35px] tw-w-[35px]")
                });
            }
        case "loader4":
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                    version: "1.1",
                    id: "L4",
                    xmlns: "http://www.w3.org/2000/svg",
                    x: "0px",
                    y: "0px",
                    width: "35px",
                    height: "35px",
                    viewBox: "-20 0 100 100",
                    enableBackground: "new 0 0 0 0",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            fill: color,
                            stroke: "none",
                            cx: "6",
                            cy: "50",
                            r: "6",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animate", {
                                attributeName: "opacity",
                                dur: "1s",
                                values: "0;1;0",
                                repeatCount: "indefinite",
                                begin: "0.1"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            fill: color,
                            stroke: "none",
                            cx: "26",
                            cy: "50",
                            r: "6",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animate", {
                                attributeName: "opacity",
                                dur: "1s",
                                values: "0;1;0",
                                repeatCount: "indefinite",
                                begin: "0.2"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            fill: color,
                            stroke: "none",
                            cx: "46",
                            cy: "50",
                            r: "6",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animate", {
                                attributeName: "opacity",
                                dur: "1s",
                                values: "0;1;0",
                                repeatCount: "indefinite",
                                begin: "0.3"
                            })
                        })
                    ]
                });
            }
        case "loader5":
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_4__/* .twMerge */ .m6)((_globalLoader_module_scss__WEBPACK_IMPORTED_MODULE_5___default().loader5), "tw-h-[16px] tw-w-[35px]")
                });
            }
        default:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Common_LoaderIcon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props));
            }
    }
};


/***/ }),

/***/ 780058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M": function() { return /* binding */ useItemClick; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(147568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(197582);
// EXTERNAL MODULE: ./src/redux/actions/catalog.js
var catalog = __webpack_require__(96031);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(913886);
;// CONCATENATED MODULE: ./src/utils/storeProductClickedDetails.js

function storeProductClickedDetails() {
    var expiresAt = new Date(new Date().getTime() + 30000);
    var sessionObject = {
        expiresAt: expiresAt,
        itemClickedData: {
            CLICKED_ITEM_X_OFFSET: scrollX,
            CLICKED_ITEM_Y_OFFSET: scrollY
        }
    };
    sessionStorage.setItem(constants/* CLICKED_ITEM_OBJ */.uI, JSON.stringify(sessionObject));
}

// EXTERNAL MODULE: ./src/utils/canShowPDPSystem.js
var canShowPDPSystem = __webpack_require__(813051);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./src/utils/productUtils.ts
var productUtils = __webpack_require__(236913);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(540190);
// EXTERNAL MODULE: ./src/utils/isStoreB2B.js
var isStoreB2B = __webpack_require__(43935);
;// CONCATENATED MODULE: ./src/hooks/useItemClick.js










function useItemClick() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var storeData = (0,es/* useSelector */.v9)(function(state) {
        return {
            storeData: state.storeReducer.store
        };
    }).storeData;
    var getProductRoute = function(product) {
        var ref;
        var productUrl = product === null || product === void 0 ? void 0 : product.link;
        var productRoute = (0,routes.getRoute)((0,productUtils/* getProductPathFromUrl */.ts)(productUrl, false), storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain);
        return productRoute;
    };
    /**
   * to go to product description page, special characters are not allowed.
   * using regex to remove all special characters with '-'
   * @param {*} item
   * @param {*} e
   */ var onItemClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(item) {
            var e, openInNewTab, ref, getRoute, productRoute, paramStr, productRouteWithParam;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : null, openInNewTab = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : false;
                        storeProductClickedDetails();
                        e && (e === null || e === void 0 ? void 0 : e.stopPropagation());
                        sessionStorage.setItem(constants/* CLICKED_ITEM_X_OFFSET */.AB, scrollX);
                        sessionStorage.setItem(constants/* CLICKED_ITEM_Y_OFFSET */.WR, scrollY);
                        return [
                            4,
                            Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 540190)).then(function(module) {
                                return module.getRoute;
                            })
                        ];
                    case 1:
                        getRoute = _state.sent();
                        return [
                            4,
                            getProductRoute(item, getRoute)
                        ];
                    case 2:
                        productRoute = _state.sent();
                        /** if color is there push with color in query params */ if (item === null || item === void 0 ? void 0 : item.color) {
                            paramStr = "?color=".concat(item === null || item === void 0 ? void 0 : item.color);
                            productRouteWithParam = productRoute + paramStr;
                            window.location.href = productRouteWithParam;
                        } else if (!(0,canShowPDPSystem/* canShowPDPSystem */.R)(storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : ref.theme_class) && !(0,isStoreB2B/* isB2BStore */.h)()) {
                            dispatch((0,catalog/* savePDPData */.zP)({
                                visible: true,
                                product: item
                            }));
                        } else {
                            openInNewTab ? window.open(productRoute, "_blank") : window.location.href = productRoute;
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function onItemClick(item) {
            return _ref.apply(this, arguments);
        };
    }();
    var getLink = function(item, getRoute) {
        var ref;
        if (!item) {
            return;
        }
        var productRoute = getProductRoute(item, getRoute);
        var productLink = "";
        if (item === null || item === void 0 ? void 0 : item.color) {
            var paramStr = "?color=".concat(item === null || item === void 0 ? void 0 : item.color);
            productLink = productRoute + paramStr;
        } else if ((0,canShowPDPSystem/* canShowPDPSystem */.R)(storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : ref.theme_class)) {
            productLink = productRoute;
        }
        return productLink || "";
    };
    return [
        onItemClick,
        getLink
    ];
}


/***/ }),

/***/ 813051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ canShowPDPSystem; }
/* harmony export */ });
var canShowPDPSystem = function(themeVar) {
    switch(themeVar){
        case 1:
            return true;
        case 2:
            return true;
        case 3:
            return false;
        case 4:
            return false;
        default:
            return true;
    }
};


/***/ }),

/***/ 5271:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ checkIsAudioPresentInVideo; }
/* harmony export */ });
function checkIsAudioPresentInVideo(param) {
    var videoRef = param.videoRef, _defaultAudioStatus = param.defaultAudioStatus, defaultAudioStatus = _defaultAudioStatus === void 0 ? true : _defaultAudioStatus;
    var ref;
    if (!videoRef) return defaultAudioStatus;
    var hasAudio = videoRef.mozHasAudio || // Firefox
    !!videoRef.webkitAudioDecodedByteCount || // Chrome (some versions)
    !!((ref = videoRef.audioTracks) === null || ref === void 0 ? void 0 : ref.length); // standard (not properly supported in chrome)
    return hasAudio;
}


/***/ }),

/***/ 154065:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ formatPriceToINR; }
/* harmony export */ });
/* harmony import */ var _checkRenderEnv__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(506337);

var formatPriceToINR = function(price) {
    var ref;
    if (!price) return price;
    if (_checkRenderEnv__WEBPACK_IMPORTED_MODULE_0__/* .IS_SERVER */ .W6) return price;
    return ((ref = price.toLocaleString) === null || ref === void 0 ? void 0 : ref.call(price, "en-IN")) || price;
};


/***/ }),

/***/ 336508:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"widgetContentFadeInWrapper":"ContentButtonAnimationStyle_widgetContentFadeInWrapper__gzPMJ","fadeIn":"ContentButtonAnimationStyle_fadeIn__Mx5Ue","widgetContentFadeInZoomInWrapper":"ContentButtonAnimationStyle_widgetContentFadeInZoomInWrapper__9exDB","fadeInZoomIn":"ContentButtonAnimationStyle_fadeInZoomIn__FGJ6r","widgetContentMoveDownWrapper":"ContentButtonAnimationStyle_widgetContentMoveDownWrapper__EWZJt","moveDown":"ContentButtonAnimationStyle_moveDown__HotCW","builderSelectorDemo":"ContentButtonAnimationStyle_builderSelectorDemo__P7Dit","demoMoveDown":"ContentButtonAnimationStyle_demoMoveDown__VsgIP","widgetContentMoveUpWrapper":"ContentButtonAnimationStyle_widgetContentMoveUpWrapper__q4jnq","moveUp":"ContentButtonAnimationStyle_moveUp__JqBuF","demoMoveUp":"ContentButtonAnimationStyle_demoMoveUp__f_z3_","widgetContentSlideLeftWrapper":"ContentButtonAnimationStyle_widgetContentSlideLeftWrapper__C_WGJ","moveLeft":"ContentButtonAnimationStyle_moveLeft__wtumW","demoMoveLeft":"ContentButtonAnimationStyle_demoMoveLeft__XAysw","widgetContentSlideRightWrapper":"ContentButtonAnimationStyle_widgetContentSlideRightWrapper__Ael_0","moveRight":"ContentButtonAnimationStyle_moveRight__NWc9p","demoMoveRight":"ContentButtonAnimationStyle_demoMoveRight__kmTdf","imageZoomIn":"ContentButtonAnimationStyle_imageZoomIn__zXH0u","imageZoomOut":"ContentButtonAnimationStyle_imageZoomOut__ywFAu","zoomInOnHover":"ContentButtonAnimationStyle_zoomInOnHover__wpSXv","ambient":"ContentButtonAnimationStyle_ambient__lq2Vz","animationAmbient":"ContentButtonAnimationStyle_animationAmbient__Mp7Dt"};

/***/ }),

/***/ 185134:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"logo1":"globalLoader_logo1__U4pxQ","logo-1":"globalLoader_logo-1__07zYZ","logo2":"globalLoader_logo2__eivVl","loader-3":"globalLoader_loader-3__8hklP","loader3":"globalLoader_loader3__m47Bj","loader5":"globalLoader_loader5__6NXRf","loader-5-1":"globalLoader_loader-5-1__pESNT","loader-5-2":"globalLoader_loader-5-2__VgxuZ"};

/***/ })

}]);